import { connect } from '@atlassian/jira-react-redux';
import { maybeRunAsUser, isRunAsUserInvalid } from '../../../../../state/selectors/run-as-user';
import type { State as SummaryState } from '../../../../../state/types';
import UserPicker from './user-picker/view.tsx';
import StatefulUserPicker from './view';

const mapStateToProps = (state: SummaryState) => ({
	UserPickerComponent: UserPicker,
	isStoredUserInvalid: isRunAsUserInvalid(state),
	storedRunAsUser: maybeRunAsUser(state).cata(
		() => ({ isValid: false, accountId: '' }),
		// @ts-expect-error - TS7006 - Parameter 'user' implicitly has an 'any' type.
		(user) => user,
	),
	summaryState: state,
});

export default connect(mapStateToProps, {})(StatefulUserPicker);
